export enum TransactionReasonsTypes {
  ERROR                       = "error",
  GAME                        = "game",
  SYSTEM                      = "system",
  BONUS                       = "bonus",
  BET                         = "bet",
  BUY_FEATURE                 = "buy-feature",
  FREE_SPIN                   = "free-spin",
  WON                         = "won",
  JACKPOT                     = "jackpot",
  LOST                        = "lost",
  VOIDED                      = "voided",
  WON_VOIDED                  = "won-voided",
  LOST_VOIDED                 = "lost-voided",
  REFUND                      = "refund",
  OFFLINE_WON                 = "offline-won",
  DEPOSIT                     = "deposit",
  WITHDRAW                    = "withdraw",
  BALANCE_CORRECTION          = "balance-correction",
  ATM_DEDUCTION               = "atm-deduction",
  BONUS_CORRECTION            = "bonus-correction",
  GAME_ISSUE                  = "game-issue",
  BONUS_APPLY                 = "bonus-apply",
  BONUS_WAGERING_TIMEOUT      = "bonus-wagering-timeout",
  BONUS_INSUFFICIENT_BALANCE  = "bonus-insufficient-balance",
  BONUS_PROFIT                = "bonus-profit",
  BONUS_CASHBACK              = "bonus-cashback",
  BONUS_CANCEL                = "bonus-cancel"
}

export enum GameCategory {
  CASINO                    = "casino",
  LIVE_CASINO               = "live-casino",
  VIRTUAL_GAMES            = "virtual-casino",
  UP_N_DOWN                 = "up-n-down",
  SPORTS                    = "sports"
}

export enum GameTag {
  REGULAR                   = "regular",
  SPECIAL                   = "special",
  BRANDED                   = "branded"
}

export enum ExportTypes {
  PDF                       = "pdf",
  CSV                       = "csv",
  EXCEL                     = "excel"
}

export enum PublishStatus {
  PUBLISHED                 = "published",
  UN_PUBLISHED              = "un-published",
  TRASH                     = "trash",
}

export enum UserTypes {
  ALL                       = "",
  GUEST                     = "guest",
  LOGGED_IN                 = "logged-in",
}

export enum UserCountTypes {
  TOTAL                     = "total",
  TEST                      = "test",
  ACTIVE                    = "active",
  PASSIVE                   = "passive",
  PENDING                   = "pending",
  BLOCKED                   = "blocked",
  DELETED                   = "deleted",
  SUSPENDED                 = "suspended",
  LOCKED                    = "locked",
  ACCOUNT_CLOSING           = "account-closing"
}

export enum AffiliateAccountTypes {
  FULL                     = "full",
  PARTIAL                  = "partial",
  MINIMAL                  = "minimal"
}

export enum SortingTypes {
  POPULAR                     = "popular",
  ASC                         = "asc",
  DESC                        = "desc",
  PROVIDER                    = "provider"
}

export enum InfoIconStatusTypes {
  ACTIVE                      = "active",
  PASSIVE                     = "passive",
  REGULAR                     = "regular"
}

export enum OTPTypes {
  EMAIL                       = "email",
  AUTHENTICATOR               = "authenticator"
}

export enum MediaTypes {
  IMAGE                       = "image",
  IFRAME                      = "iframe",
  VIDEO                       = "video"
}

export enum PlatformTypes {
  BOTH                        = "both",
  DESKTOP                     = "desktop",
  MOBILE                      = "mobile"
}

export enum DomainBarHideMode {
  ALWAYS_SHOW                 = "always-show",
  SESSION                     = "session",
  UNTIL_DOMAIN_CHANGE         = "until-domain-change"
}

export enum SiteElementsTypes {
  DOMAIN_BAR                  = "domain-bar",
  COOKIE_BAR                  = "cookie-bar",
  BACK_TO_TOP                 = "back-to-top"
}

export enum ChangeFrequencyTypes {
  INHERIT                   = "inherit",
  ALWAYS                    = "always",
  HOURLY                    = "hourly",
  DAILY                     = "daily",
  WEEKLY                    = "weekly",
  MONTHLY                   = "monthly",
  YEARLY                    = "yearly",
  NEVER                     = "never"
}

export enum PagePriority {
  INHERIT                   = -1,
  ONE_POINT_ZERO            = 1,
  ZERO_POINT_NINE           = 0.9,
  ZERO_POINT_EIGHT          = 0.8,
  ZERO_POINT_SEVEN          = 0.7,
  ZERO_POINT_SIX            = 0.6,
  ZERO_POINT_FIVE           = 0.5,
  ZERO_POINT_FOUR           = 0.4,
  ZERO_POINT_THREE          = 0.3,
  ZERO_POINT_TWO            = 0.2,
  ZERO_POINT_ONE            = 0.1,
  ZERO                      = 0
}

export enum PageTypes {
  GENERIC                   = "generic",
  HOME                      = "home",
  SLOTS                     = "slots",
  LIVE_CASINO               = "live-casino",
  VIRTUAL_GAMES             = "virtual-games",
  GAME_LIST                 = "game-list",
  TOURNAMENTS               = "tournaments",
  PROMOTIONS                = "promotions",
  HELP                      = "help"
}

export enum PageDesktopComponents { 
  SLIDER                    = "slider",
  SLIDER_DOUBLE             = "slider-double",
  IMAGE                     = "image",
  SPACER                    = "spacer",
  TWO_LAYOUT_BOXES          = "two-layout-boxes",
  FOUR_LAYOUT_BOXES         = "four-layout-boxes",
  SIX_LAYOUT_BOXES          = "six-layout-boxes",
  EIGHT_LAYOUT_BOXES        = "eight-layout-boxes",
  FEATURED_GAMES            = "featured-games",
  CASINO_FEATURED           = "casino-featured",
  GAME_CATEGORIES           = "game-categories",
  GAME_PROVIDERS            = "game-providers",
  GAMES_GRID                = "games-grid",
  INDEPENDENTS_GAMES_GRID   = "independents-games-grid",
  PROMOTION_TABS            = "promotion-tabs",
  PROMOTIONS_GRID           = "promotions-grid",
  MULTIPLE_JACKPOTS         = "multiple-jackpots",
  RESULT                    = "result",
  HELP                      = "help"
}

export enum PageMobileComponents { 
  SLIDER                    = "mobile-slider",
  IMAGE                     = "mobile-image",
  SPACER                    = "mobile-spacer",
  SUB_PAGE_HEADER           = "mobile-sub-page-header",
  TWO_LAYOUT_BOXES          = "mobile-two-layout-boxes",
  FOUR_LAYOUT_BOXES         = "mobile-four-layout-boxes",
  EIGHT_LAYOUT_BOXES        = "mobile-eight-layout-boxes",
  GAME_CAROUSEL             = "mobile-game-carousel",
  PROMOTION_TABS            = "mobile-promotion-tabs",
  PROMOTIONS_GRID           = "mobile-promotions-grid",
  GAME_NAVIGATOR            = "mobile-game-navigator",
  GAME_FILTER               = "mobile-game-filter",
  GAME_CATEGORIES           = "mobile-game-categories",
  GAME_SEARCH               = "mobile-game-search",
  GAMES_GRID                = "mobile-games-grid",
  INDEPENDENTS_GAMES_GRID   = "mobile-independents-games-grid",
  RESULT                    = "mobile-result",
  HELP                      = "mobile-help",
  CASINO_WINNERS            = "mobile-casino-winners",
  CASINO_TOURNAMENTS        = "mobile-casino-tournaments",
  MULTIPLE_JACKPOTS         = "mobile-multiple-jackpots"
}

export enum PopupTypes {
  REGISTRATION              = "registration",
  RUNTIME                   = "runtime",
  PAGE                      = "page",
}

export enum ActionTypes {
  NONE                      = "no-action",
  URL                       = "url",
  PAGE                      = "page",
  GAME                      = "game",
  POPUP                     = "popup",
  PROMOTION                 = "promotion",
  SYSTEM_ACTIONS            = "system-actions"
}

export enum SystemActions {
  DEPOSIT                   = "deposit",
  WITHDRAW                  = "withdraw",
  BONUS_REQUEST             = "bonus-request",
  VIP                       = "vip",
  SIGN_IN                   = "sign-in",
  SIGN_UP                   = "sign-up",
  LIVE_SUPPORT              = "live-support",
  MEGA_MENU                 = "mega-menu",
  MY_PROFILE                = "my-profile",
  MY_FAVORITES              = "my-favorites",
  ACTIVE_BONUS              = "active-bonus",
  BONUS_ACTIVATION          = "bonus-activation",
  FREE_SPIN_ACTIVATION      = "free-spin-activation",
  PAYMENT_HISTORY           = "payment-history",
  GAME_HISTORY              = "game-history",
  BONUS_HISTORY             = "bonus-history",
  FREE_SPIN_HISTORY         = "free-spin-history",
  MESSAGES                  = "messages",
  SETTINGS                  = "settings",
  NOTIFICATIONS             = "notifications"
}

export enum Target {
  SELF                      = "_self",
  BLANK                     = "_blank",
  TOP                       = "_top"
}

export enum ContentOperationType {
  ADD                      = "add",
  EDIT                     = "edit",
  VIEW                     = "view"
}

export enum MegaMenuTypes {
  NONE          = "",
  SINGLE        = "single",
  COLLAPSIBLE   = "collapsible",
  OPEN_GROUP    = "open-group",
}

export enum DomainStatus {
  WAITING_ZONE              = "waiting-zone",
  WAITING_QUOTA             = "waiting-quota",
  REQUESTING                = "requesting",
  GETTING_DNS_RECORDS       = "getting-dns-records",
  APPLYING_DNS_RECORDS      = "applying-dns-records",
  PENDING                   = "pending",
  READY                     = "ready",
  DELETING                  = "deleting",
  DELETED                   = "deleted",
  NEXT                      = "next",
  CURRENT                   = "current",
  PREVIOUS                  = "previous",
  NEW                       = "new",
  NS_CHECKING               = "ns-checking",
  MASTER                    = "master"
}

export enum CodeLanguages {
  CSS                       = "css",
  JS                        = "js",
  HTML                      = "html",
  JSON                      = "json"
}

export enum CustomCodes {
  CSS                       = "css",
  START_OF_HEAD_TAG         = "start_of_head_tag",
  END_OF_HEAD_TAG           = "end_of_head_tag",
  START_OF_BODY_TAG         = "start_of_body_tag",
  END_OF_BODY_TAG           = "end_of_body_tag"
}

export enum PageBackground {
  IMAGE                     = "image",
  BACKGROUND_COLOR          = "background_color",
  POSITION_HORIZONTAL       = "position_horizontal",
  POSITION_VERTICAL         = "position_vertical",
  REPEAT                    = "repeat",
  SIZE                      = "size"
}

export enum Meta {
  DESCRIPTION               = "description",
  KEYWORDS                  = "keywords",
  TITLE                     = "title"
}

export enum ImageOptimization {
  OPTIMIZE                  = "optimize",
  ORIGINAL                  = "original"
}

export enum ForgotPasswordAction {
  LINK                      = "link",
  HELPDESK                  = "helpdesk"
}

export enum OpenGameAction {
  MODAL                     = "modal",
  BLANK                     = "blank",
  SELF                      = "self"
}

export enum ChangeFrequency {
  ALWAYS                    = "always",   // Very frequently changing content (e.g. live crypto prices)
  HOURLY                    = "hourly",   // Pages updated hourly (e.g. news feed)
  DAILY                     = "daily",    // Pages updated daily (e.g. promotions, blog)
  WEEKLY                    = "weekly",   // Weekly content (e.g. tournaments, newsletters)
  MONTHLY                   = "monthly",  // Monthly updates (e.g. help pages)
  YEARLY                    = "yearly",   // Pages that rarely change (e.g. about us)
  NEVER                     = "never"     // Archive pages, historical content (e.g. 2020 campaign)
}

export enum AdminStatus {
  PENDING                   = "pending",
  ACTIVE                    = "active",
  DEACTIVATED               = "deactivated",
  DELETED                   = "deleted"
}

export enum AdminRoles {
  ROOT                      = "root"
}

export enum AffiliateRequestStatus {
  PENDING                   = "pending",
  APPROVED                  = "approved",
  DECLINED                  = "declined",
}

export enum ProfileStatus {
  ACTIVE                    = "active",
  PASSIVE                   = "passive",
  PENDING                   = "pending",
  BLOCKED                   = "blocked",
  DELETED                   = "deleted",
  SUSPENDED                 = "suspended",
  LOCKED                    = "locked",
  DEACTIVATED               = "deactivated",
  ACCOUNT_CLOSING           = "account-closing"
}

export enum UserStatus {
  PENDING                   = "pending",
  ACTIVE                    = "active",
  PASSIVE                   = "passive",
  BLOCKED                   = "blocked",
  DELETED                   = "deleted",
  SUSPENDED                 = "suspended",
  LOCKED                    = "locked",
  ACCOUNT_CLOSING           = "account-closing",
  REPETITIVE_KYC            = "repetitive-kyc"
}

export enum AffiliateStatus {
  PENDING                   = "pending",
  ACTIVE                    = "active",
  DELETED                   = "deleted",
  SUSPENDED                 = "suspended",
  DECLINED                  = "declined"
}

export enum AffiliateCommissionType {
  FIXED                     = "fixed",
  RATE                      = "rate"
}

export enum AffiliateAllowanceType {
  REVENUE_SHARE             = "revenue_share",
  NET_REVENUE               = "net_revenue",
  NET_REVENUE_WITH_BONUS    = "net_revenue_with_bonus",
  DETAILED_EXPENSE          = "detailed_expense",
  TIERED_FIXED              = "tiered_fixed",
  TIERED_PERCENTAGE         = "tiered_percentage"
}

export enum UserRiskLevel {
  LOW                       = "low",
  MEDIUM                    = "medium",
  HIGH                      = "high"
}

export enum UserTransactionStatus {
  OPEN                      = "open",
  PENDING                   = "pending"
}

export enum UserTransactionRequestTypes {
  ALL                       = "all",
  DEPOSIT                   = "deposit",
  WITHDRAW                  = "withdraw",
  SYSTEM                    = "system",
  GAME                      = "game"
}

export enum UserTransactionReason {
  DEPOSIT                   = "deposit",
  WITHDRAW                  = "withdraw",
  BONUS                     = "bonus",
  MANUAL                    = "manual"
}

export enum TransactionTypes {
  DEPOSIT                   = "deposit",
  WITHDRAW                  = "withdraw"
}

export enum TransactionErrorTypes {
  STATUS                      = "status",
  BAN                         = "ban",
  BALANCE                     = "balance",
  LIMIT                       = "limit",
  REPETITIVE                   = "repetitive",
}

export enum TransactionDeclineReason {
  USER_STATUS_CHANGED                       = "user-status-changed",
  CLIENT_STATUS_CHANGED                     = "client-status-changed",
  CATEGORY_STATUS_CHANGED                   = "category-status-changed",
  PROVIDER_STATUS_CHANGED                   = "provider-status-changed",
  GAME_STATUS_CHANGED                       = "game-status-changed",
  SEGMENT_CATEGORY_STATUS_CHANGED           = "segment-category-status-changed",
  SEGMENT_PROVIDER_STATUS_CHANGED           = "segment-provider-status-changed",
  SEGMENT_GAME_STATUS_CHANGED               = "segment-game-status-changed",
  GAME_SESSION_BANNED                       = "game-session-banned",
  INSUFFICIENT_FREE_BALANCE                 = "insufficient-free-balance",
  INSUFFICIENT_BONUS_BALANCE                = "insufficient-bonus-balance",
  USER_SELF_DAILY_BET_LIMIT_EXCEEDED        = "user-self-daily-bet-limit-exceeded",
  USER_SELF_DAILY_LOST_LIMIT_EXCEEDED       = "user-self-daily-lost-limit-exceeded",
  SEGMENT_CATEGORY_PER_TURN_LIMIT_EXCEEDED  = "segment-category-per-turn-limit-exceeded",
  SEGMENT_PROVIDER_PER_TURN_LIMIT_EXCEEDED  = "segment-provider-per-turn-limit-exceeded",
  SEGMENT_GAME_PER_TURN_LIMIT_EXCEEDED      = "segment-game-per-turn-limit-exceeded",
  USER_CATEGORY_PER_TURN_LIMIT_EXCEEDED     = "user-category-per-turn-limit-exceeded",
  USER_CATEGORY_DAILY_LIMIT_EXCEEDED        = "user-category-daily-limit-exceeded",
  USER_PROVIDER_PER_TURN_LIMIT_EXCEEDED     = "user-provider-per-turn-limit-exceeded",
  USER_PROVIDER_DAILY_LIMIT_EXCEEDED        = "user-provider-daily-limit-exceeded",
  USER_GAME_PER_TURN_LIMIT_EXCEEDED         = "user-game-per-turn-limit-exceeded",
  USER_GAME_DAILY_LIMIT_EXCEEDED            = "user-game-daily-limit-exceeded",
  REPETITIVE_TRANSACTION                    = "repetitive-transaction",
  INTERNAL_SERVER_ERROR                     = "internal-server-error"
}

export enum Permissions {
  NONE                          = "",
  DASHBOARD                     = "dashboard",
  USER_MANAGEMENT               = "user-management",
  ADMIN_MANAGEMENT              = "admin-management",
  AFFILIATE_MANAGEMENT          = "affiliate-management",
  ROLE_MANAGEMENT               = "role-management",
  FINANCE_WITHDRAW_MANAGEMENT   = "finance-withdraw-management",
  FINANCE_DEPOSIT_MANAGEMENT    = "finance-deposit-management",
  FINANCE_BONUS_MANAGEMENT      = "finance-bonus-management",
  FINANCIAL_MANAGEMENT          = "financial-management",
  GAME_MANAGEMENT               = "game-management",
  GAME_REPORTS                  = "game-reports",
  USER_REPORTS                  = "user-reports",
  FINANCE_REPORTS               = "finance-reports",
  DOMAIN_MANAGEMENT             = "domain-management",
  BONUS_MANAGEMENT              = "bonus-management",
  SEGMENTATION_MANAGEMENT       = "segmentation-management",
  FREE_SPIN_MANAGEMENT          = "free-spin-management",
  CONTENT_MANAGEMENT            = "content-management",
  USER_LIMITATIONS              = "user-limitations",
  BONUS_TRANSFER                = "bonus-transfer",
  LOGIN_REPORTS                 = "login-reports",
  AFFILIATE_REPORTS             = "affiliate-reports",
  GAME_COMMISSIONS              = "game-comissions",
  PAYMENT_COMMISSIONS           = "payment-comissions",
  CRM_DECLINE_REASONS           = "crm-decline-reasons",
  CRM_USER_LABELS               = "crm-user-labels",
  BACKOFFICE_ADDRESSES          = "backoffice-addresses"
}

export enum VisibilityStatus {
  ACTIVE                    = "active",
  PENDING                   = "pending",
  EXPIRED                   = "expired",
}

export enum TransactionStatus {
  APPLIED                   = "applied",
  ACTIVE                    = "active",
  OPEN                      = "open",
  PENDING                   = "pending",
  APPROVED                  = "approved",
  APPROVED_BY_MANAGEMENT    = "approved-by-management",
  APPROVED_BY_PROVIDER      = "approved-by-provider",
  DECLINED_BY_MANAGEMENT    = "declined-by-management",
  DECLINED_BY_PROVIDER      = "declined-by-provider",
  DECLINED                  = "declined",
  CANCELLED                 = "cancelled",
  TIMEOUT                   = "time-out",
  REJECTED                  = "rejected",
  IN_PROGRESS               = "in-progress",
  COMPLETED                 = "completed",
  EXPIRED                   = "expired",
  LOST_BY_TIMEOUT           = "lost-by-timeout",
  LOST_BY_BALANCE           = "lost-by-balance"
}

export enum BonusTypes {
  MANUAL                    = "manual",
  DEPOSIT                   = "deposit",
  LOSS                      = "loss",
  TRIAL                     = "trial"
}

export enum BonusWalletTypes {
  FREE                      = "free",
  TRIAL                     = "trial",
  CASINO                    = "casino",
  SPORTS                    = "sports"
}

export enum BonusStatus {
  EMPTY                     = "",
  OPEN                      = "open",
  PENDING_AUTOSTART         = "pending-autostart",
  ACTIVE                    = "active",
  CANCELLED                 = "cancelled",
  SUSPENDED                 = "suspended",
  DECLINED                  = "declined",
  ENDED                     = "ended",
  DELETED                   = "deleted",
  PENDING                   = "pending"
}

export enum BonusCalculationTypes {
  FIXED_AMOUNT              = "fixed_amount",
  FIXED_PERCENT             = "fixed_percent",
  AMOUNT_RANGE              = "ranged_amount",
  PERCENT_RANGE             = "ranged_percent"
}

export enum FreeSpinCalculationTypes {
  FIXED                     = "fixed",
  RANGED                    = "ranged"
}

export enum BonusTimeRanges {
  STATIC                      = "static",
  HOUR_WITHIN                 = "hour-within",
  DAY_WITHIN                  = "day-within",
  WEEK_WITHIN                 = "week-within",
  MONTH_WITHIN                = "month-within"
}

export enum MultiApplyTimeRanges {
  UNLIMITED                   = "unlimited",
  HOUR_WITHIN                 = "hour-within",
  DAY_WITHIN                  = "day-within",
  WEEK_WITHIN                 = "week-within",
  MONTH_WITHIN                = "month-within"
}

export enum AdminTypes {
  CLIENT                      = "client",
  MASTER                      = "master",
  AFFILIATE                   = "affiliate",
}

export enum PaymentTypes {
  DEPOSIT                     = "deposit",
  WITHDRAW                    = "withdraw"
}

export enum BonusWarningTypes {
  PAYMENT_METHOD_DISABLED     = "payment-method-disabled",
  GAME_BRAND_DISABLED         = "game-brand-disabled",
  GAME_DISABLED               = "game-disabled"
}

export enum BonusFinanceStatus {
  ACTIVE                      = "active",
  OPEN                        = "open",
  PENDING                     = "pending",
  APPROVED                    = "approved",
  EXPIRED                     = "expired",
  COMPLETED                   = "completed",
  DECLINED                    = "declined",
  REJECTED                    = "rejected",
  CANCELLED                   = "cancelled",
  LOST_BY_TIMEOUT             = "lost-by-timeout",
  LOST_BY_BALANCE             = "lost-by-balance",
}

export enum FreeSpinPeriods {
  UNLIMITED                   = "unlimited",
  ALL_TIME                    = "all_time",
  DAILY                       = "daily",
  WEEKLY                      = "weekly",
  MONTHLY                     = "monthly"
}

export enum FreeSpinStatus {
  APPLIED                     = "applied",
  REJECTED                    = "rejected",
  CANCELLED                   = "cancelled",
  ACCEPTED                    = "accepted",
  COMPLETED                   = "completed",
  TIMEOUT                     = "time-out"
}

export enum FreeSpinCampaignStatus {
  ACTIVE                      = "active",
  CANCELLED                   = "cancelled",
  DELETED                     = "deleted"
}

export enum UserDeclineNoteTypes {
  DEPOSIT                     = "deposit",
  WITHDRAW                    = "withdraw",
  BONUS                       = "bonus"
}

export enum UserUpdateImportantFields {
  FULL_NAME                   = "full-name",
  DATE_OF_BIRTH               = "date-of-birth",
  ID_NUMBER                   = "id-number",
  PHONE                       = "phone",
  EMAIL                       = "email"
}

export enum UserAccessMaskedFields {
  PHONE                       = "phone",
  EMAIL                       = "email",
  DATE_OF_BIRTH               = "date-of-birth",
  ID_NUMBER                   = "id-number",
  COMMISSION                  = "commission"
}

export enum AffiliateUpdateImportantFields {
  FULL_NAME                   = "full-name",
  DATE_OF_BIRTH               = "date-of-birth",
  ID_NUMBER                   = "id-number",
  PHONE                       = "phone",
  EMAIL                       = "email"
}

export enum CRUD {
  CREATE  = "create",
  READ    = "read",
  UPDATE  = "update",
  DELETE  = "delete"
}

/**
 * 
 * API Predefined Field Values
 * 
 * **TOKEN**
 * Indicates a warning related to the X-Auth-Token value sent in the request header. This usually signifies that the session has ended.
 * 
 * **USER**
 * Refers to a data blockage or issue related to the session's user in the Site API responses.
 * 
 * **USER_SETTINGS**
 * Refers to a data blockage or issue related to the session's user settings in the Site API responses.
 * 
 * **PASSWORD**
 * Refers to a data blockage or issue related to the session's user password in the Site API responses.
 * 
 * **ADMIN**
 * Refers to a data blockage or issue related to the session's user in the Backoffice API responses.
 * 
 * **PRIVACY_POLICY**
 * Indicates that the session's user needs to approve new rules in the Site API responses.
 * 
 * @description These are the predefined field values that can be returned by the API.
 * 
 * @see https://staging-affiliate.itdev.ae/api/docs/index.html
 * 
 */
export enum APIPredefinedFieldValues {
  TOKEN                             = "TOKEN",
  USER                              = "USER",
  USER_SETTINGS                     = "USER_SETTINGS",
  PASSWORD                          = "PASSWORD",
  ADMIN                             = "ADMIN",
  PRIVACY_POLICY                    = "PRIVACY_POLICY"
}

/**
 * 
 * API Predefined Code Values
 * 
 * **REQUIRED**
 * Indicates that the field is mandatory.
 * 
 * **EXPIRED**
 * Indicates that the item associated with the field is no longer valid.
 * 
 * **INVALID**
 * Indicates that the content of the field is invalid/incorrect.
 * 
 * **NOT_IN_RANGE**
 * Indicates that the content of the field is not in allowed range.
 * 
 * **EXISTS**
 * Indicates that the record attempted to be created related to the field already exists.
 * 
 * **NOT_ACTIVE**
 * Indicates that the item associated with the field is inactive for some reason.
 * 
 * **SUSPENDED**
 * Indicates that the operations related to the item associated with the field have been suspended.
 * 
 * **LIMIT_EXCEEDED**
 * Indicates that the operation related to the field has hit a single operation limit.
 * 
 * **DAILY_LIMIT_EXCEEDED**
 * Indicates that the operation related to the field has hit a daily limit.
 * 
 * **WEEKLY_LIMIT_EXCEEDED**
 * Indicates that the operation related to the field has hit a weekly limit.
 * 
 * **MONTHLY_LIMIT_EXCEEDED**
 * Indicates that the operation related to the field has hit a monthly limit.
 * 
 * **YEARLY_LIMIT_EXCEEDED**
 * Indicates that the operation related to the field has hit a yearly limit.
 * 
 * **IN_USE**
 * Indicates that the operation related to the field is blocked by another record or operation (indicating a dependency).
 * 
 * @description These are the predefined code values that can be returned by the API.
 * 
 * @see https://staging-affiliate.itdev.ae/api/docs/index.html
 * 
 */
export enum APIPredefinedCodeValues {
  BLOCKED                           = "BLOCKED",
  LIMIT_EXCEEDED                    = "LIMIT_EXCEEDED",
  REQUIRED                          = "REQUIRED",
  EXPIRED                           = "EXPIRED",
  INVALID                           = "INVALID",
  NOT_IN_RANGE                      = "NOT_IN_RANGE",
  EXISTS                            = "EXISTS",
  NOT_ACTIVE                        = "NOT_ACTIVE",
  SUSPENDED                         = "SUSPENDED",
  DAILY_LIMIT_EXCEEDED              = "DAILY_LIMIT_EXCEEDED",
  WEEKLY_LIMIT_EXCEEDED             = "WEEKLY_LIMIT_EXCEEDED",
  MONTHLY_LIMIT_EXCEEDED            = "MONTHLY_LIMIT_EXCEEDED",
  YEARLY_LIMIT_EXCEEDED             = "YEARLY_LIMIT_EXCEEDED",
  IN_USE                            = "IN_USE",
  HAS_OPEN                          = "HAS_OPEN",
  HAS_PENDING                       = "HAS_PENDING",
  PROVIDER_ERROR                    = "PROVIDER_ERROR",
  NOT_SUPPORTED                     = "NOT_SUPPORTED"
}

export enum APIErrorTypes {
  PERMISSION_DENY                   = "PERMISSION_DENY",
  MALFORMED_DATA                    = "MALFORMED_DATA"
}

export enum APIErrorDetails {
  MULTI_GAME_CAMPAIGN_DISABLED_FOR_GAME_PROVIDER  = "multi game campaign is disabled for game provider",
  PROVIDED_HEX_STRING_IS_NOT_A_VALID_OBJECT_ID    = "the provided hex string is not a valid ObjectID"
}

export enum ErrorTypes {
  BAD_REQUEST                         = "BAD_REQUEST",
  UNAUTHORIZED_USER                   = "UNAUTHORIZED_USER",
  RESOURCE_NOT_FOUND                  = "RESOURCE_NOT_FOUND",
  TIMEOUT                             = "TIMEOUT",
  REQUEST_ENTITY_TOO_LARGE            = "REQUEST_ENTITY_TOO_LARGE",
  INTERNAL_SERVER_ERROR               = "INTERNAL_SERVER_ERROR",
  BAD_GATEWAY                         = "BAD_GATEWAY",
  SERVICE_TEMPORARILY_UNAVAILABLE     = "SERVICE_TEMPORARILY_UNAVAILABLE",
  PROXY_ERROR                         = "PROXY_ERROR",
  FORBIDDEN                           = "FORBIDDEN",
  NO_RESPONSE                         = "NO_RESPONSE"
}